export default class NotificationSettingsModel {
    /* tslint:disable:variable-name */
    public _id?: string = ''
    public category_type?: string
    public unit_selector_id?: string
    public recipients?: any[] = ['']
    public detail?: string = ''
    public created_at?: Date = new Date()
    public updated_at?: Date = new Date()

    constructor(category_type = 'geofence') {
        this.category_type = category_type
    }
}
